import Vue from "vue";
import Router from "vue-router";
import Aktuelles from "./views/Aktuelles.vue";
import Referenzen from "./views/Referenzen.vue";
import About from "./views/About.vue";
import Kontakt from "./views/Kontakt.vue";
import Impressum from "./views/Impressum.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "aktuelles",
      component: Aktuelles
    },
    {
      path: "/referenzen",
      name: "referenzen",
      component: Referenzen
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: Kontakt
    },
    {
      path: "/impressum",
      name: "impressum",
      component: Impressum
    }
  ]
});
